import { Component, OnInit } from '@angular/core';
import { DialogService } from '../dialog';

@Component({
  selector: 'q-comp-notfound',
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.css']
})

export class NotFoundComponent implements OnInit {

  errorUrl: string = '';

  constructor(
    private dialog: DialogService
  ) { }

  ngOnInit(): void {
    this.dialog.showSplash(false);
    const url: string | null = localStorage.getItem('unfoundroute');
    this.errorUrl = (url) ? url : '';
    localStorage.removeItem('unfoundroute');
  }
}
